declare var _sr: any;

import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-masonrygrid',
  templateUrl: './masonrygrid.component.html',
  styleUrls: ['./masonrygrid.component.scss'],
})
export class MasonrygridComponent implements OnInit {

    static componentName = 'MasonrygridComponent';
    @Input()images: Array<any>;

    ngOnInit() {
        setTimeout(() => {
            _sr.reveal('div.image-wrap > div.image');
        }, 1000);
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/masonrygrid/masonrygrid.component.ts